import styled from "styled-components";
import { TasksTodos } from "./TasksTodos";
import { useTranslation } from "@coworker/locales";
import { TaskTabsTypes } from "../../../shared/constants/taskTabsTypes";
import { useTasksFilters } from "../../../activity/hooks/useTasksFilters";
import { useTeamId, useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useActivityData } from "@coworker/apprestructured/src/activity/hooks/useActivityData";
import { DEFAULT_FILTER_VALUES } from "@coworker/apprestructured/src/activity/constants/defaultFilterValues";
import { ActivityColumns } from "@coworker/apprestructured/src/activity/constants/activityColumns";

const TasksTodosOuterContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 24px;
  padding-top: 16px;
  padding-right: 16px;
  > * {
    width: 100%;
  }
  @media (min-width: 1440px) {
    padding-top: 32px;
    gap: -16px;
    > * {
      width: 49%;
    }
  }
  margin-bottom: 16px;
`;

export const TasksPreview = () => {
  const { t } = useTranslation();
  const { useFiltersFactory, filterValues, setFilterValues } =
    useTasksFilters();
  const filters = useFiltersFactory(filterValues);

  const uid = useUID();
  const teamId = useTeamId();

  const { inProgressTasks: myTasks } = useActivityData(
    {
      ...DEFAULT_FILTER_VALUES,
      assignedTo: uid,
    },
    ActivityColumns.IN_PROGRESS
  );

  const { openTasks } = useActivityData(
    { ...DEFAULT_FILTER_VALUES, assignedTo: teamId },
    ActivityColumns.OPEN
  );

  return (
    <TasksTodosOuterContainer>
      <TasksTodos
        title={t("myString")}
        tabType={TaskTabsTypes.MY}
        tasksCount={myTasks.data?.pages[0]?.filteredCount || 0}
        hideViewButton={openTasks.data?.pages[0]?.list.length === 0}
        tasksList={myTasks.data?.pages[0]?.list.slice(0, 3) ?? []}
        isLoading={myTasks?.isLoading as boolean}
        filters={filters}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
      />
      <TasksTodos
        title={t("openTasksString")}
        tabType={TaskTabsTypes.OPEN}
        tasksCount={openTasks.data?.pages[0]?.filteredCount || 0}
        tasksList={openTasks.data?.pages[0]?.list.slice(0, 3) ?? []}
        isLoading={openTasks?.isLoading as boolean}
        filters={filters}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
      />
    </TasksTodosOuterContainer>
  );
};
